import * as React from 'react';
import type { SVGProps } from 'react';
const SvgWord = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width={32}
    height={32}
    fill='none'
    {...props}
  >
    <rect width={32} height={32} fill='url(#word_svg__a)' rx={6} />
    <defs>
      <pattern id='word_svg__a' width={1} height={1} patternContentUnits='objectBoundingBox'>
        <use xlinkHref='#word_svg__b' transform='matrix(.00083 0 0 .00083 0 .035)' />
      </pattern>
      <image
        xlinkHref='/images/icons/word-c1d71632.webp'
        id='word_svg__b'
        width={1200}
        height={1117}
        preserveAspectRatio='none'
      />
    </defs>
  </svg>
);
export default SvgWord;
